import React from 'react'
import MenuGuideButton from '../components/MenuGuideButton'

export default function BulkSmsPage() {
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <h1 className="text-2xl font-bold">단체문자발송</h1>
        <MenuGuideButton slug="bulk-sms" title="단체문자발송 가이드" />
      </div>
      <div className="rounded border p-4 text-sm text-slate-700">
        현재 기능 준비 중입니다.
      </div>
    </div>
  )
}

